const ORDER_CHIME = [
  { frequency: 659.25, offset: 0.00, duration: 0.38 },
  { frequency: 783.99, offset: 0.34, duration: 0.38 },
  { frequency: 987.77, offset: 0.68, duration: 0.52 },
  { frequency: 783.99, offset: 1.16, duration: 0.72 },
];

export function playOrderNotification(ctx, requestedVolume = 0.75) {
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});

  const volume = Math.max(0.05, Math.min(1, Number(requestedVolume) || 0.75));
  const start = ctx.currentTime + 0.02;

  ORDER_CHIME.forEach(({ frequency, offset, duration }) => {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    const at = start + offset;

    oscillator.type = "triangle";
    oscillator.frequency.setValueAtTime(frequency, at);
    gain.gain.setValueAtTime(0.001, at);
    gain.gain.exponentialRampToValueAtTime(volume * 0.55, at + 0.035);
    gain.gain.exponentialRampToValueAtTime(volume * 0.38, at + Math.min(0.18, duration / 2));
    gain.gain.exponentialRampToValueAtTime(0.001, at + duration);
    oscillator.connect(gain).connect(ctx.destination);
    oscillator.start(at);
    oscillator.stop(at + duration);
  });
}
